// extracted by mini-css-extract-plugin
module.exports = {"content":"Settings_content__28G1l","secondaryMenu":"Settings_secondaryMenu__gsWjr"};